'use client'

import { motion } from 'framer-motion'
import { TrendingUp, Users, Eye } from 'lucide-react'
import { useTranslations } from 'next-intl'
import DashboardMockup from './DashboardMockup'
import MockupFrame from './MockupFrame'
import '../../sass/landing/ProductShowcase.scss'

const ProductShowcase = () => {
  const t = useTranslations('LandingV2.showcase')

  return (
    <section className='showcase'>
      <div className='showcase__container'>
        <div className='showcase__header'>
          <span className='landing-v2__chip'>{t('chip')}</span>
          <h2>{t('heading')}</h2>
          <p>{t('description')}</p>
        </div>

        <motion.div
          className='showcase__frame'
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <MockupFrame>
            <DashboardMockup />
          </MockupFrame>

          <motion.div
            className='showcase__stat showcase__stat--1'
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <div className='showcase__stat-icon'>
              <TrendingUp />
            </div>
            <div className='showcase__stat-text'>
              <span className='showcase__stat-value'>{t('stat1Value')}</span>
              <span className='showcase__stat-label'>{t('stat1Label')}</span>
            </div>
          </motion.div>

          <motion.div
            className='showcase__stat showcase__stat--2'
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <div className='showcase__stat-icon'>
              <Users />
            </div>
            <div className='showcase__stat-text'>
              <span className='showcase__stat-value'>{t('stat2Value')}</span>
              <span className='showcase__stat-label'>{t('stat2Label')}</span>
            </div>
          </motion.div>

          <motion.div
            className='showcase__stat showcase__stat--3'
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <div className='showcase__stat-icon'>
              <Eye />
            </div>
            <div className='showcase__stat-text'>
              <span className='showcase__stat-value'>{t('stat3Value')}</span>
              <span className='showcase__stat-label'>{t('stat3Label')}</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

export default ProductShowcase
